webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Calculadora__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Calculadora: __WEBPACK_IMPORTED_MODULE_0__components_Calculadora__["a" /* default */]
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      resultado: 0,
      operadorClick: false,
      operador: null,
      anterior: null,
      puntito: false
    };
  },

  methods: {
    borrar: function borrar() {
      this.resultado = 0;
    },
    signo: function signo() {
      this.resultado = this.resultado < 0 ? this.resultado = this.resultado - this.resultado * 2 : this.resultado = this.resultado - this.resultado * 2;
    },
    porcentaje: function porcentaje() {
      this.resultado = this.resultado / 100;
    },
    agregar: function agregar(numero) {
      console.log('Valor de operadorClick: ' + this.operadorClick);
      console.log('Valor de puntito: ' + this.puntito);
      if (this.operadorClick && !this.puntito) {
        this.resultado = numero;
        this.operadorClick = false;
      } else {
        if (this.operadorClick && this.puntito) {
          this.resultado = '' + this.resultado + numero;
          this.puntito = false;
          this.operadorClick = false;
        } else {
          this.resultado = this.resultado === 0 ? this.resultado = numero : '' + this.resultado + numero;
        }
      }
    },
    puntoDecimal: function puntoDecimal() {
      if (this.operadorClick) {
        console.log('Rosita');
        this.resultado = '0.';
        this.puntito = true;
      }
      if (/\d+\.+/g.test(this.resultado)) {
        console.log('Decimal');
      } else {
        this.resultado = this.resultado + '.';
      }
    },
    dividir: function dividir() {
      this.operador = function (a, b) {
        return a / b;
      };
      this.anterior = this.resultado;
      this.operadorClick = true;
    },
    multiplicar: function multiplicar() {
      this.operador = function (a, b) {
        return a * b;
      };
      this.anterior = this.resultado;
      this.operadorClick = true;
    },
    restar: function restar() {
      this.operador = function (a, b) {
        return a - b;
      };
      this.anterior = this.resultado;
      this.operadorClick = true;
    },
    sumar: function sumar() {
      this.operador = function (a, b) {
        return a + b;
      };
      this.anterior = this.resultado;
      this.operadorClick = true;
    },
    igual: function igual() {
      console.log('Entramos a igual');
      this.resultado = this.operador(Number(this.anterior), Number(this.resultado));
      this.anterior = null;
      this.operadorClick = true;
    }
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a5cf79_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(15);
function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a5cf79_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculadora_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1cc9da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculadora_vue__ = __webpack_require__(14);
function injectStyle (ssrContext) {
  __webpack_require__(13)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculadora_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f1cc9da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculadora_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculadora",attrs:{"onselectstart":"return false"}},[_c('div',{staticClass:"resultado"},[_vm._v(_vm._s(_vm.resultado))]),_vm._v(" "),_c('div',{staticClass:"btn oscuro",on:{"click":function($event){return _vm.borrar()}}},[_vm._v("C")]),_vm._v(" "),_c('div',{staticClass:"btn oscuro",on:{"click":function($event){return _vm.signo()}}},[_vm._v("+/-")]),_vm._v(" "),_c('div',{staticClass:"btn oscuro",on:{"click":function($event){return _vm.porcentaje()}}},[_vm._v("%")]),_vm._v(" "),_c('div',{staticClass:"btn operador",on:{"click":function($event){return _vm.dividir()}}},[_vm._v("/")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(7)}}},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(8)}}},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(9)}}},[_vm._v("9")]),_vm._v(" "),_c('div',{staticClass:"btn operador",on:{"click":function($event){return _vm.multiplicar()}}},[_vm._v("*")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(4)}}},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(5)}}},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(6)}}},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"btn operador",on:{"click":function($event){return _vm.restar()}}},[_vm._v("-")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(1)}}},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(2)}}},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.agregar(3)}}},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"btn operador",on:{"click":function($event){return _vm.sumar()}}},[_vm._v("+")]),_vm._v(" "),_c('div',{staticClass:"btn cero btn-abajo",on:{"click":function($event){return _vm.agregar(0)}}},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"btn btn-abajo",on:{"click":function($event){return _vm.puntoDecimal()}}},[_vm._v(".")]),_vm._v(" "),_c('div',{staticClass:"btn operador btn-abajo",on:{"click":function($event){return _vm.igual()},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.igual()}}},[_vm._v("=")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('main',[_c('Calculadora')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('span',[_vm._v("Vue.js - PWA - Calculadora")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.b58d021eca0915ca9e10.js